import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState, useEffect } from "react";
import {
    createAPICollateralReallocation,
    EndpointCollateralReallocation,
} from "../../Services/CollateralReallocation/CollateralReallocationService";
import storage from "../../Services/Storage";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
// import { createGlobalStyle } from "styled-components";
import { toast } from "react-toastify";
// import { Checkbox } from "primereact/checkbox";
import Loader from "../../Components/Loader";

const CollateralReallocation = () => {
    const auth = storage.getLocal("user");
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState(null);
    const [partyname, setPartyname] = useState([]);
    const [dcConfirmation, setDcConfirmation] = useState();
    const [deallocatedPopUp, setDeallocatedPopUp] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loaderdt, setLoaderdt] = useState(false);
    const [deallocatedRowData, setDeallocatedRowData] = useState([]);
    const [selectedDistList, setSelectedDistList] = useState([]);

    const getPopulateCustomer = async () => {
        try {
            setLoader(true);
            const res = await createAPICollateralReallocation().get(
                `${EndpointCollateralReallocation.PopulateCustomer}?CompId=${auth.CompId}`
            );
            setPartynamesugg(res?.data?.Data);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoader(false);
        }
    };
    const getGetDCforConfirmation = async () => {
        try {
            setLoader(true);
            const res = await createAPICollateralReallocation().get(
                `${EndpointCollateralReallocation.GetDCforConfirmation}?CompId=${auth.CompId}`
            );
            setDcConfirmation(res?.data?.lstDCDetailData);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoader(false);
        }
    };

    const confirmDeallocate = async (rowData) => {
        setDeallocatedRowData(rowData);
        setDeallocatedPopUp(true);
    };
    const saveDeallocate = async () => {
        // console.log(selectedDistList);
        // console.log(partynamesugg);
        if (selectedDistList.length == 0) {
            toast.warn("Please select GRN to proceed", {
                position: "top-center",
                autoClose: 3000,
            });
            return;
        }
        if (selectedDistList.length > 3) {
            toast.warn("You can select maximum three items to save.", {
                position: "top-center",
                autoClose: 3000,
            });
            return;
        }

        let checkPartyIds = () => {
            let errorItems = [];
            selectedDistList.forEach((item) => {
                const isFound = partynamesugg.some(
                    (secondItem) => secondItem.MASK_CUST_ID === item.PARTY_ID
                );
                if (!isFound) {
                    errorItems.push(item);
                }
            });
            return errorItems;
        };
        let checkconfIds = () => {
            let errorItems = [];
            selectedDistList.forEach((item) => {
                if(item.CONFIRMATION_STATUS=="N"){
                    errorItems.push(item);
                }
            });
            return errorItems;
        };
        let errorchk = checkPartyIds();
        let errorchkconf = checkconfIds();
        // console.log(errorchkconf);
        if (errorchkconf.length > 0 ) {
            errorchkconf.forEach((item) =>
                toast.warn(
                    `GRN No ${item.GRN_NO} is not Confirmed yet`,
                    {
                        position: "top-center",
                        autoClose: 4000,
                    }
                )
            );
            return;
        }

        if (errorchk.length > 0 ) {
            errorchk.forEach((item) =>
                toast.warn(
                    `GRN No ${item.GRN_NO} Cannot be converted to Delivery Challan. Please Check Customer Details for More Information`,
                    {
                        position: "top-center",
                        autoClose: 4000,
                    }
                )
            );
            return;
        } else {
            let listsave = selectedDistList.map((item) => {
                return {
                    id: item.ID,
                    inV_NO: item.INV_NO,
                    inV_DATE: item.INV_DATE,
                    grN_ID: item.GRN_ID,
                    grN_NO: item.GRN_NO,
                    grN_DATE: item.GRN_DATE,
                    disT_CODE: item.DIST_CODE,
                    cusT_CODE: item.CUST_CODE,
                    partY_NAME: item.PARTY_NAME,
                    partY_ID: item.PARTY_ID,
                    confirmatioN_STATUS: item.CONFIRMATION_STATUS,
                    awb: item.AWB,
                };
            });
            let payload = {
                userId: auth.UserId,
                compId: auth.CompId,
                masK_CUST_ID: "",
                objDetl: listsave,
            };

            // console.log(payload);
            // return;
            try {
                setLoader(true);
                const res = await createAPICollateralReallocation().post(
                    `${EndpointCollateralReallocation.SaveDeallocate}`,
                    payload
                );
                console.log(res.data,"Colateral-Reallocsave");
                getGetDCforConfirmation();
                setSelectedDistList([]);
                if(res?.data?.Status=="Success"){
                    toast.success(res?.data?.Message);
                }
                else{
                    toast.warn(res?.data?.Message);
                }
            } catch (error) {
                console.log("error ", error);
            }finally{
                setLoader(false);
            }
        }

    };

    // useEffect(() => { console.log("data ", customerData); }, [customerData]);

    useEffect(() => {
        
        getPopulateCustomer();
        getGetDCforConfirmation();
    }, []);

    const procedFurther = async () => {
        if (onchangepartyname == null) {
            toast.info("Please select customer", {
                position: "top-center",
                autoClose: 3000,
            });
            return;
        }
        setDeallocatedPopUp(false);
        // console.log("onchangepartyname", onchangepartyname);
        // console.log(deallocatedRowData);
        const payload = {
            userId: auth.UserId,
            compId: auth.CompId,
            masK_CUST_Id: onchangepartyname.MASK_CUST_ID,
            cusT_CODE: onchangepartyname.CODE,
            id: deallocatedRowData.ID,
        };
        // console.log(payload);
        // return;
        try {
            setLoaderdt(true);
            const res = await createAPICollateralReallocation().post(
                `${EndpointCollateralReallocation.ConfirmDeallocate}`,
                payload
            );
            toast.success("Deallocation Saved Successfully", {
                position: "top-center",
                autoClose: 3000,
            });
            setOnchangepartyname(null);
            getGetDCforConfirmation();
            console.log("res confirmDeallocate ", res);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoaderdt(false);
        }
    };
    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return employee.NAME.toLowerCase().includes(e.query.toLowerCase());
                });
            }

            setPartyname(_filteredemployee);
        }, 400);
    };

    const employeeTemplate = (employee) => {
        return <>{employee.NAME}</>;
    };
    const rowExpansionTemplate = (data) => {
        return (
            <DataTable value={data.lstDCDetailData} responsiveLayout="scroll">
                <Column field="PROD_CODE" header="Product Code	" />
                <Column field="PROD_DESC" header="Product Description" />
                <Column field="REASON" header="Reason" />
                <Column field="RECEIVED_QUANTITY" header="Quantity" />
            </DataTable>
        );
    };

    const [expandedRows, setExpandedRows] = useState([]);

    const onRowToggle = (e) => {
        setExpandedRows(e.data);
    };
    // const selectionColumn = (rowData) => {
    //     if (rowData.CONFIRMATION_STATUS === "Y") {
    //         return <Column selectionMode="multiple" />;
    //     } else {
    //         return null;
    //     }
    // };

    // const handleCheckboxChange1 = (rowData) => {
    //     const isSelected = selectedDistList?.some(
    //         (item) => item.GRN_ID === rowData.GRN_ID
    //     );
    //     console.log(isSelected);
    //     if (isSelected) {
    //         setSelectedDistList((prevList) =>
    //             prevList?.filter((item) => item.GRN_ID !== rowData.GRN_ID)
    //         );
    //     } else {
    //         setSelectedDistList((prevList) => [...prevList, rowData]);
    //     }
    // };

    // const handleCheckboxChange = (rowData) => {
    //     setSelectedDistList((prevList) => {
    //         const isSelected = prevList.some(
    //             (item) => item.GRN_ID === rowData.GRN_ID
    //         );

    //         if (isSelected) {
    //             return prevList.filter((item) => item.GRN_ID !== rowData.GRN_ID);
    //         } else {
    //             return [...prevList, rowData];
    //         }
    //     });
    // };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Collateral Re-allocation</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={saveDeallocate}
                            >
                Save
                            </button>
                        </div>
                    </div>
                </div>
                {loaderdt?<><Loader/></>:null}

                {loader?<><Loader/></>:<section className="">
                    <div className="DataTable">
                        <DataTable
                            value={dcConfirmation}
                            rows={10}
                            filterDisplay="row"
                            stripedRows
                            scrollHeight="80vh"
                            scrollable
                            paginator
                            expandedRows={expandedRows}
                            onRowToggle={onRowToggle}
                            rowExpansionTemplate={rowExpansionTemplate}
                            dataKey="GRN_ID"
                            selection={selectedDistList}
                            onSelectionChange={(e) => setSelectedDistList(e.value)}
                            selectionMode="checkbox"
                            showSelectAll={false}
                        >
                            {/* <Column
                headerStyle={{ width: "3rem" }}
                dataKey={(rowData) => rowData.GRN_ID}
                body={(rowData) =>
                  rowData.CONFIRMATION_STATUS === "Y" ? (
                    <Checkbox
                      value={rowData}
                      onChange={() => handleCheckboxChange(rowData)}
                      checked={selectedDistList?.some(
                        (item) => item.GRN_ID === rowData.GRN_ID
                      )}
                      key={rowData.GRN_ID}
                    />
                  ) : null
                }
              /> */}
                            {/* <Column
              
                selectionMode={"multiple"}
                header="Select All"
                headerStyle={{ width: "5rem" }}
              ></Column> */}
                            {dcConfirmation?.some(
                                (row) => row?.CONFIRMATION_STATUS === "Y"
                            ) && (
                                <Column
                                    selectionMode="multiple"
                                    header="Select"
                                    headerStyle={{ width: "5rem" }}
                                />
                            )}
                            <Column expander style={{ width: "3em" }} />
                            <Column field="GRN_NO" header="GRN Number" filterMatchMode="contains"
                                filter
                                filterPlaceholder="Search Here..." />
                            <Column field="GRN_DATE" header="GRN Date" filterMatchMode="contains"
                                filter
                                filterPlaceholder="Search Here..." />
                            <Column field="CUST_CODE" header="Customer Code"  filterMatchMode="contains"
                                filter
                                filterPlaceholder="Search Here..."/>
                            <Column field="PARTY_NAME" header="Customer Name" filterMatchMode="contains"
                                filter
                                filterPlaceholder="Search Here..."/>
                            <Column field="AWB" header="AWB" />
                            <Column
                                field=""
                                header="Action"
                                body={(rowData) =>
                                    rowData.CONFIRMATION_STATUS === "Y" || rowData.CONFIRMATION_STATUS === "R" ? (
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => confirmDeallocate(rowData)}
                                            style={{ fontSize: "11px" }}
                                        >
                                            De-Allocate
                                        </button>
                                    ) : (rowData.CONFIRMATION_STATUS === "A" ? (
                                        <span className="text-success">Approved</span>
                                    ) : (
                                        <span className="text-danger">Awating for Approval</span>
                                    )
                                    )
                                }
                            />
                        </DataTable>
                    </div>
                </section>}
            </div>
            <Dialog
                header="Information"
                visible={deallocatedPopUp}
                style={{ width: "50vw" }}
                draggable={false}
                resizable={false}
                closable={false}
            >
                <div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <label className="form-label">Customer Name</label>
                        <AutoComplete
                            field="NAME"
                            value={onchangepartyname}
                            suggestions={partyname}
                            completeMethod={searchEmployee}
                            onChange={(e) => {
                                setOnchangepartyname(e?.value);
                            }}
                            dropdown={true}
                            forceSelection
                            itemTemplate={employeeTemplate}
                            emptyMessage="No Customer found."
                            showEmptyMessage
                        />
                    </div>
                </div>
                <div className="float-end mt-4">
                    <button
                        type="button"
                        className="btn btn-primary me-3"
                        onClick={procedFurther}
                    >
            Confirm
                    </button>
                    <button
                        type="button"
                        className="btn btn-cancel-red"
                        onClick={() => {
                            setDeallocatedPopUp(false);
                            setOnchangepartyname(null);
                        }}
                    >
            Cancel
                    </button>
                </div>
            </Dialog>
        </>
    );
};

export default CollateralReallocation;
